/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface SolrOrganisationReduced
 */
export interface SolrOrganisationReduced  {
    /**
     * 
     * @type {string}
     * @memberof SolrOrganisationReduced
     */
    id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SolrOrganisationReduced
     */
    name?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SolrOrganisationReduced
     */
    hierarchy?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SolrOrganisationReduced
     */
    gnd?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof SolrOrganisationReduced
     */
    recordCreationDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SolrOrganisationReduced
     */
    recordChangeDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof SolrOrganisationReduced
     */
    editorialStatus?: string;
}

/**
 * Check if a given object implements the SolrOrganisationReduced interface.
 */
export function instanceOfSolrOrganisationReduced(value: object): value is SolrOrganisationReduced {
    return true;
}

export function SolrOrganisationReducedFromJSON(json: any): SolrOrganisationReduced {
    return SolrOrganisationReducedFromJSONTyped(json, false);
}

export function SolrOrganisationReducedFromJSONTyped(json: any, ignoreDiscriminator: boolean): SolrOrganisationReduced {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
              'name': json['name'] == null ? undefined : json['name'],
              'hierarchy': json['hierarchy'] == null ? undefined : json['hierarchy'],
              'gnd': json['gnd'] == null ? undefined : json['gnd'],
                'recordCreationDate': json['recordCreationDate'] == null ? undefined : (new Date(json['recordCreationDate'])),
                'recordChangeDate': json['recordChangeDate'] == null ? undefined : (new Date(json['recordChangeDate'])),
                  'editorialStatus': json['editorialStatus'] == null ? undefined : json['editorialStatus'],
    };
}

export function SolrOrganisationReducedToJSON(json: any): SolrOrganisationReduced {
    return SolrOrganisationReducedToJSONTyped(json, false);
}

export function SolrOrganisationReducedToJSONTyped(value?: SolrOrganisationReduced | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'] == null? value['name']: value['name'],
        'hierarchy': value['hierarchy'] == null? value['hierarchy']: value['hierarchy'],
        'gnd': value['gnd'] == null? value['gnd']: value['gnd'],
        'recordCreationDate': value['recordCreationDate']?.toISOString(),
        'recordChangeDate': value['recordChangeDate']?.toISOString(),
        'editorialStatus': value['editorialStatus'],
    };
}


